import { b as addItemById, a as contexts } from './cart-8130b675.js';
import { E as EVENTS } from './events-21b4b022.js';

class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      quickShopButton: "[js-quick-shop-button]",
      quickShopButtonWrapper: "[js-quick-shop-button-wrapper]",
      quickShopError: "[js-quick-shop-error]",
      swatchImages: "[js-product-item-swatch-image]",
      swatches: "[js-swatch]",
      swatchOverflowButton: "[js-product-listing-swatch-overflow]",
    };

    this.classes = {
      hasError: "has-error",
      active: "active",
      adding: "adding",
      success: "success",
      swatchActive: "swatch-active",
      selectedSwatch: "swatch--selected",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();
    this.quickShopButton = this.querySelector(this.selectors.quickShopButton);
    this.quickShopButtonWrapper = this.querySelector(
      this.selectors.quickShopButtonWrapper,
    );
    this.swatchImages = this.querySelectorAll(this.selectors.swatchImages);
    this.swatches = this.querySelectorAll(this.selectors.swatches);
    this.swatchOverflowButton = this.querySelector(
      this.selectors.swatchOverflowButton,
    );

    // Initialize quick shop functionality
    if (this.quickShopButton) {
      this.quickShopType = this.quickShopButton.getAttribute("data-type");
      this.hasVariants =
        this.quickShopButton.getAttribute("data-has-variants") === "true";

      // Listen for click on quick shop button
      this.quickShopButton.addEventListener(
        "click",
        this.handleQuickShopClick.bind(this),
        { signal: this.controller.signal },
      );

      // If quick shop type is "quick-add" and the product has no variants, add
      // listeners for:
      //   - quick-add success
      //   - quick-add failure
      //   - cart update (clear error)
      if (this.quickShopType === "quick-add" && !this.hasVariants) {
        this.addEventListener(
          EVENTS.QUICK_ADD_SUCCESS,
          this.handleQuickAddSuccess.bind(this),
          { signal: this.controller.signal },
        );

        this.quickShopError = this.querySelector(this.selectors.quickShopError);

        this.addEventListener(
          EVENTS.QUICK_ADD_ERROR,
          this.handleQuickAddError.bind(this),
          { signal: this.controller.signal },
        );

        document.addEventListener(
          EVENTS.CART_CHANGED,
          this.handleCartUpdate.bind(this),
          { signal: this.controller.signal },
        );
      }

      // Listen for "quick add" error to show message and update button state
      this.quickShopButton.addEventListener(
        EVENTS.QUICK_ADD_ERROR,
        this.handleQuickAddError.bind(this),
        { signal: this.controller.signal },
      );
    }

    // If we have swatches, add click listeners to each swatch
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleSwatchClick.bind(this), {
        signal: this.controller.signal,
      });
    });

    // If we have swatch overflow, add a click listener
    if (this.swatchOverflowButton && this.quickShopButton) {
      this.swatchOverflowButton.addEventListener(
        "click",
        this.handleSwatchOverflowClick.bind(this),
        { signal: this.controller.signal },
      );
    }
  }

  handleQuickShopClick() {
    if (this.quickShopType === "quick-add" && !this.hasVariants) {
      this.handleQuickAdd();
    } else {
      this.openQuickView();
    }
  }

  handleQuickAdd() {
    this.quickShopButtonWrapper.dispatchEvent(
      new CustomEvent(EVENTS.BUTTON_STATE_STARTED),
    );

    addItemById(
      this.quickShopButton.dataset.variantId,
      1,
      contexts.productItem,
      this,
    );
  }

  handleQuickAddSuccess() {
    this.quickShopButtonWrapper.dispatchEvent(
      new CustomEvent(EVENTS.BUTTON_STATE_COMPLETED),
    );
    this.classList.remove(this.classes.hasError);
  }

  handleQuickAddError(event) {
    this.quickShopButtonWrapper.dispatchEvent(
      new CustomEvent(EVENTS.BUTTON_STATE_INCOMPLETED),
    );

    this.classList.add(this.classes.hasError);
    this.quickShopError.innerText = event.detail.errorMessage;
  }

  handleCartUpdate() {
    console.log("Cart was updated");
    this.classList.remove(this.classes.hasError);
  }

  openQuickView() {
    // TODO: Hook this into the modal pattern to show quick view
    alert("Should open quick view modal");
  }

  handleSwatchClick(event) {
    const swatch = event.currentTarget;

    // If the swatch is already selected, deselect it and return
    if (swatch.classList.contains(this.classes.selectedSwatch)) {
      swatch.classList.remove(this.classes.selectedSwatch);
      this.classList.remove(this.classes.swatchActive);

      for (let i = 0; i < this.swatchImages.length; i++) {
        const swatchImage = this.swatchImages[i];

        if (swatchImage.dataset.swatchValue === swatch.dataset.value) {
          swatchImage.classList.remove(this.classes.active);
          break
        }
      }

      return
    }

    // Hide currently active swatch image
    this.swatchImages.forEach((swatchImage) => {
      swatchImage.classList.remove(this.classes.active);
    });

    // Deselect all swatches
    this.swatches.forEach((swatch) => {
      swatch.classList.remove(this.classes.selectedSwatch);
    });

    // Select the current swatch and show the associated image
    swatch.classList.add(this.classes.selectedSwatch);

    let foundSwatchImage = false;

    for (let i = 0; i < this.swatchImages.length; i++) {
      const swatchImage = this.swatchImages[i];

      if (swatchImage.dataset.swatchValue === swatch.dataset.value) {
        this.classList.add(this.classes.swatchActive);
        swatchImage.classList.add(this.classes.active);
        foundSwatchImage = true;
        break
      }
    }

    if (!foundSwatchImage) {
      this.classList.remove(this.classes.swatchActive);
    }
  }

  handleSwatchOverflowClick() {
    this.openQuickView();
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("product-item")) {
  customElements.define("product-item", ProductItem);
}
